"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Context = _interopRequireDefault(require("../Context"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var withTheme = function withTheme(WrappedComponent) {
  function HOC(props) {
    return /*#__PURE__*/_react["default"].createElement(_Context["default"].Consumer, null, function (value) {
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, value, props));
    });
  }
  HOC.displayName = WrappedComponent.displayName || 'withTheme';
  return HOC;
};
var _default = exports["default"] = withTheme;